module.exports = __webpack_public_path__ + "img/step-4.7b548c83.jpg";